import MasterBatangan from "./MasterBatangan.vue";
import MasterBatanganAdd from "./MasterBatanganAdd.vue";
import MasterBatanganDetail from "./MasterBatanganDetail.vue";
import MasterBatanganEdit from "./MasterBatanganEdit.vue";
import MasterBatanganUpload from "./MasterBatanganUpload.vue";

let routesMasterBatangan = [
    
    {
        path: '',
        meta: {
          title: "Chain System",
        },
        name: "MasterBatanganIndex",
        component: MasterBatangan
    },
    {
        path: 'add',
        meta: {
          title: "Chain System",
        },
        name: "MasterBatanganAdd",
        component: MasterBatanganAdd
    },
    {
        path: 'detail/:id',
        meta: {
          title: "Chain System",
        },
        name: "MasterBatanganDetail",
        component: MasterBatanganDetail
    },
    {
        path: 'edit/:id',
        meta: {
          title: "Chain System",
        },
        name: "MasterBatanganEdit",
        component: MasterBatanganEdit
    },
    {
        path: 'upload',
        meta: {
          title: "Chain System",
        },
        name: "MasterBatanganUpload",
        component: MasterBatanganUpload
    },
   
  ]
  
  export default routesMasterBatangan
